import type { FC } from "react";
import Icon from "../../../../components/general/Icon";

import * as s from "./FormInformation.module.scss";

type FormInformationProps = {
	icon: string;
	label: string;
	information: string;
};

const FormInformation: FC<FormInformationProps> = ({
	icon,
	label,
	information,
}) => (
	<div className={s.information}>
		<Icon icon={icon} />
		<span>
			<label>{label}</label>
			<p>{information}</p>
		</span>
	</div>
);

export default FormInformation;
